import { cn } from '@/lib/utils';
import type { InputProps } from '@/types/components.types';

export const Input = ({ className, ...props }: InputProps) => (
  <input
    className={cn(
      'bg-zinc-950 border border-zinc-800 rounded-lg px-4 py-2',
      'text-zinc-50 placeholder:text-zinc-600 w-full',
      'focus:outline-none focus:ring-2 focus:ring-violet-500/50 focus:border-violet-500',
      'transition-colors',
      className,
    )}
    {...props}
  />
);
